'use strict';

class RepresentanteController {
  constructor($log, $scope, DataService, Message, Util, Loading) {
    'ngInject';
    this.$log = $log;
    this.$scope = $scope;
    this.DataService = DataService;
    this.Message = Message;
    this.Util = Util;
    this.Loading = Loading;
    this.axs = {};
    this.departamentos = [];
    this.estadosCivil = [];
    this.formatos = [];
  }
  $onInit() {
    this.get = {}; // variable que guarda respuestas de gets
    this.axs = {
      change_propietario: true, // evitara que se autoguarde por primera vez el representante y las veces q se asigne true
      conf: {}
    };
    this.initJsonData();
    this.cargarDepartamentosExpedido();
    this.cargarEstadoCivil();
    this.cargarFormatoInfo();
  }
  cancel() {
    this.$uibModalInstance.close();
    // this.$uibModalInstance.dismiss('cancel');
  }
  representanteChange(form) {
    if (this.tieneMatricula) {
      for (var k in this.data.hist_representantes) {
        if (k != 'tipo_documento') {
          delete this.data.hist_representantes[k];
        }
      }
      this.data.hist_representantes.tipo_documento = this.data.propietario_representante == 'PROPIETARIO' ? 'CARNET_IDENTIDAD' : 'FUNDEMPRESA';
      this.axs.change_propietario = true; // sw_propietario
      this.Util.setTouchedForm(form, false);
      this.axs.sw_propietario = this.data.propietario_representante == 'PROPIETARIO';
      this.representantesRestore();
    } else {
      this.axs.change_propietario = false;
      this.representanteUpd();
    }
  }

  representantesRestore() {
    if (this.axs.rep_backup.propietario_representante == 'REPRESENTANTE' && this.data.propietario_representante == 'REPRESENTANTE') {
      angular.extend(this.data.hist_representantes, this.axs.rep_backup.hist_representantes);
    } else if (this.axs.rep_backup.propietario_representante == 'PROPIETARIO' && this.data.propietario_representante == 'PROPIETARIO') {
      angular.extend(this.data.hist_representantes, this.axs.rep_backup.hist_representantes);
    }
  }
  initJsonData() {
    if (this.data.propietario_representante == 'PROPIETARIO' || (this.data.propietario_representante == 'REPRESENTANTE' && !this.tiene_matricula)) {
      this.axs.change_propietario = false;
    }
    this.initDefault(this.data, 'propietario_representante', 'PROPIETARIO');
    if (this.data.propietario_representante == 'PROPIETARIO') {
      this.axs.sw_propietario = true;
    }
    if (this.data.propietario_representante == 'REPRESENTANTE' && !this.tiene_matricula) {
      this.axs.sw_propietario = true;
    }
    this.axs.rep_backup = {
      propietario_representante: angular.copy(this.data.propietario_representante),
      hist_representantes: angular.copy(this.data.hist_representantes)
    };
  }
  initDefault(obj, key, val) {
    if (!obj[key])
      obj[key] = val;
  }
  cargarDepartamentosExpedido() {
    var url = `parametros/?grupo=DEPARTAMENTO_MEF`;    
    this.DataService.get(url)
    .then((response) => {
      this.departamentos = response;
    });
  }
  cargarEstadoCivil() {
    var url = `parametros/?grupo=ESTADO_CIVIL`;    
    this.DataService.get(url)
    .then((response) => {
      this.estadosCivil = response;
    });
  }
  cargarFormatoInfo() {
    var url = `parametros/?grupo=FORMATO_INF_MEF`;    
    this.DataService.get(url)
    .then((response) => {
      this.formatos = response;
    });
  }

}

export default RepresentanteController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/forms/representanteLegal/representante.controller.js